import { render, staticRenderFns } from "./OrderSourcePie.vue?vue&type=template&id=7f53c468&"
import script from "./OrderSourcePie.vue?vue&type=script&lang=js&"
export * from "./OrderSourcePie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports